import {
  HierarchicalDropdown,
  HierarchicalDropdownNode,
} from '@hawkins-community/hierarchicaldropdown';
import { Card, CardBody, DropdownOption, Input } from '@hawkins/components';
import { useSensorModeLookup } from 'src/domains/api/cameras';
import { CameraSensorMode } from 'src/domains/api/cameras/types';
import styles from './CameraAndSensoreModeInput.module.css';
import { CustomResolutionInput } from './CustomResolutionInput';
import { HorizontalInputStack } from './HorizontalInputStack';
import { ResolutionInput } from '../FramingChart/types';

interface CameraAndSensorModeInputProps {
  sensorMode?: DropdownOption<CameraSensorMode> | null;
  onSensorModeChange: (
    selected: HierarchicalDropdownNode<
      CameraSensorMode,
      'children',
      'value'
    > | null
  ) => void;
}

export const CameraAndSensorModeInput = ({
  sensorMode,
  onSensorModeChange,
}: CameraAndSensorModeInputProps) => {
  const sensorModeLookup = useSensorModeLookup();

  const isCustomCamera = sensorMode?.value?.id === 'custom';

  const updateSensorMode = (
    updates: Partial<
      Pick<CameraSensorMode, 'horizontal' | 'vertical' | 'cameraName' | 'name'>
    >
  ) => {
    onSensorModeChange({
      label: sensorMode?.label,
      value: {
        ...sensorMode?.value,
        ...updates,
      } as CameraSensorMode,
    });
  };

  return (
    <>
      <HierarchicalDropdown<CameraSensorMode, 'children', 'value'>
        searchable
        multi={false}
        label="Camera and Sensor Mode"
        placeholder="Select a Camera and Sensor Mode"
        options={sensorModeLookup}
        childPropName="children"
        value={sensorMode}
        onChange={(_event, selected) => {
          onSensorModeChange(selected);
        }}
      />
      {isCustomCamera && (
        <>
          <CustomResolutionInput
            customHeight={sensorMode?.value?.vertical}
            customWidth={sensorMode?.value?.horizontal}
            onChange={({ width, height }: ResolutionInput) => {
              console.log('Custom sensor mode changed:', {
                width,
                height,
              });
              updateSensorMode({
                horizontal: width ?? sensorMode?.value?.horizontal,
                vertical: height ?? sensorMode?.value?.vertical,
              });
            }}
          />

          <Card>
            <CardBody className={styles.customCameraInputs}>
              <HorizontalInputStack>
                <Input
                  label="Camera Name"
                  placeholder="Enter camera name"
                  value={sensorMode?.value?.cameraName ?? ''}
                  onChange={(e) => {
                    const updatedCameraName = e.target.value;
                    updateSensorMode({
                      cameraName: updatedCameraName,
                    });
                  }}
                />

                <Input
                  label="Sensor Mode Name"
                  placeholder="Enter sensor mode name"
                  value={sensorMode?.value?.name ?? ''}
                  onChange={(e) => {
                    const updatedSensorModeName = e.target.value;
                    updateSensorMode({
                      name: updatedSensorModeName,
                    });
                  }}
                />
              </HorizontalInputStack>
            </CardBody>
          </Card>
        </>
      )}
    </>
  );
};
